import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/NfoWnhbsdVZiFJds5"
            >
              <CFImage src={mobileMap} w="100%" alt="To Dine For Eatery Map" />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/NfoWnhbsdVZiFJds5"
            >
              <CFImage
                src={locationMap}
                w="100%"
                alt="To Dine For Eatery Map"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
